import styled from 'styled-components/macro';
import { Images } from 'assets/images';
import {
  FONTS,
  FONT_FAMILY,
  COLORS,
  BREAKPOINTS,
  FLEX_CONTAINER,
} from 'utils/styles';

export const SelectContainer = styled.div`
  width: 100%;
  height: 310px;
  padding-left: 28px;
  margin-top: 20px;

  @media only screen and ${BREAKPOINTS.xl} {
    padding-left: 28px;
  }

  @media only screen and ${BREAKPOINTS.lg} {
    padding-left: 28px;
  }

  @media only screen and ${BREAKPOINTS.md} {
    padding-left: unset;
  }
`;

export const QuestionText = styled.label`
  color: ${COLORS.mainColor};
  ${FONTS.font20};
  ${FONT_FAMILY.FontMedium};
`;

export const QuestionAnswerContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  width: 100%;
  height: 100px;
`;

export const SelectElement = styled.select`
  -webkit-appearance: none;
  background: url(${Images.selectIcon}) no-repeat 96%;
  ${FLEX_CONTAINER.Unset};
  border: 1px solid ${COLORS.mainColor};
  width: 300px;
  height: 48px;
  color: ${COLORS.mainColor};
  padding-right: 16px;
  padding-left: 16px;
  border-radius: 14px;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 25px;
  text-overflow: ellipsis;
  @media only screen and ${BREAKPOINTS.md} {
    width: 100%;
    background: url(${Images.selectIcon}) no-repeat 96%;
  }
`;

export const OptionElement = styled.option`
  overflow: hidden;
  width: 300px;
  ${FONTS.font16};
`;
